import { Button, Text, VStack } from "@chakra-ui/react";
import { isRouteErrorResponse, Link, useRouteError } from "react-router-dom";
import { colors } from "../../styles";
import { useAuthStore } from "../../store";
import { forceLogout } from "../../utils";

export default function Suspended() {

    /* render */

    return (
        <VStack
            width={"100%"}
            minHeight={"100vh"}
            justifyContent={"center"}
            alignItems={"center"}
            gap={5}
            padding={5}
            textAlign={"center"}
        >
            <Text fontSize={24} fontWeight={500} color={colors.black}>
                영구 정지된 계정입니다
            </Text>
                
            <Button
                color={colors.blue}
                size={"lg"}
                onClick={() => forceLogout()}
            >
                로그아웃하기
            </Button>
        </VStack>
    );
}
